<template>
  <div id="app">
    <template v-if="query">
      <div class="main-card centered">
        <span class="icon">✅</span>
        <div>
          <p class="title">You're done!</p>
          <p class="subheader">The app should open shortly</p>
        </div>
        <button class="button main-button" @click="closeTab">Close tab</button>
      </div>

      <div class="bottom main-card">
        <p>Nothing appearing ?</p>
        <button class="button second-button" @click="openExternal">Download the app</button>
      </div>
    </template>
    <template v-else>
      <div class="main-card centered root">
        <img
          src="https://raw.githubusercontent.com/WebCreationClub/construct-addon-installer/develop/store/Addoninstaller%20Icon%20(96).png"
          alt="icon">
        <div>
          <p class="title">📦 🚀 Addon Installer</p>
          <p class="subheader">Never worry about installing an addon by hand again 💪</p>
        </div>
        <button class="button second-button" @click="openExternal">Download the app</button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      query: null,
    };
  },
  methods: {
    closeTab() {
      window.close();
    },
    openExternal() {
      window.open('https://github.com/WebCreationClub/construct-addon-installer', '_blank');
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.query = urlParams.get('q');
    if (this.query) window.location.replace(`addoninstaller://${this.query}`);
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto');

  html {
    font-family: 'Roboto', sans-serif;
    background: #282828;
    color: #fff;
  }

  .bottom {
    position: fixed;
    bottom: -60px;

    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
    min-width: 475px;
    transition: bottom .5s;
  }

  .bottom:hover {
    position: fixed;
    bottom: 10px;

    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
    min-width: 475px;
  }

  .main-card {
    background-color: #383838;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    text-align: center;
  }

  .centered {
    padding: 20px 45px;
    font-size: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    min-width: 300px;
    width: 35%;
  }
  .root {
    min-width: 580px;
  }

  .button {
    background-color: #484848;
    border: 1px solid #303030;
    width: 200px;
    height: 35px;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
  }

  .main-button {
    margin-top: 25px;
  }

  .second-button {
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .title {
    font-size: 25px;
  }

  .subheader {
    color: grey;
    line-height: 0;
  }

  .icon {
    font-size: 35px;
  }

  a {
    color: grey;
  }

  a:visited {
    color: darkgrey;
  }
</style>
